/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from 'class-transformer';
import { SmBaseEntity } from 'src/modules/sm-base/shared/sm-base-entity.model';
import { Column, Entity } from 'typeorm';

@Entity()
export class FinalGradeHistory extends SmBaseEntity {
    @Column({default: 0})
    pupilId: number = 0;

    @Column({default: 0})
    year: number = 0;

    @Column({default: ""})
    domain: string = "";

    @Column({default: ""})
    transactionGuid: string = "";

    @Column({default: ""})
    changedBy: string = "";

    @Column()
    @Type(() => Date)
    changeDate: Date;

    @Column({default: ""})
    modification: string = "";

    constructor(pupilId = 0, year = 0, domain = "", modification = "") {
        super();
        this.pupilId = pupilId;
        this.year = year;
        this.domain = domain;
        this.modification = modification ?? "";
    }
}
